import { getEnvironmentName } from '@hc-frontend/business'
import { FunnelContextData } from 'Snowplow'

/**
 * Channels that represent agent-assisted sessions. Everything else (dtc, unknown,
 * empty, affiliates, ecommerce) is treated as direct-to-consumer. user_type is set
 * explicitly from the channel — never inferred from the presence of an agent_id,
 * since DTC sessions carry a house agent_id.
 */
const AGENT_CHANNELS = ['brokerage', 'call center', 'indy sales center']

const ENVIRONMENT_MAP: Record<string, FunnelContextData['environment']> = {
  QA: 'qa',
  STG: 'staging',
  PROD: 'production'
}

function readChannel(): string {
  try {
    const hcData = JSON.parse(window.localStorage.getItem('hc') || 'null')
    return (hcData.channel.channelName || '').toLocaleLowerCase()
  } catch (error) {
    return ''
  }
}

const localStorageFunnelProvider = {
  readFunnelContextData: (): FunnelContextData => {
    const channel = readChannel()

    return {
      funnel_type: 'legacy',
      funnel_version: null,
      user_type: AGENT_CHANNELS.includes(channel) ? 'agent' : 'dtc',
      environment: ENVIRONMENT_MAP[getEnvironmentName()] || 'production'
    }
  }
}

export { localStorageFunnelProvider }
